import type { AccesARemettre } from '../api/identifiants'

/**
 * Accès d'un compte tout juste créé.
 *
 *  • e-mail (avec ou sans numéro) → e-mail + mot de passe temporaire, affiché une seule fois ;
 *  • numéro WhatsApp seul → PAS de mot de passe : « La personne se connecte avec son numéro WhatsApp » ;
 *  • compte déjà existant → on le dit (jamais de « null » à l'écran).
 */
export function BlocIdentifiants({
  acces,
  introduction,
}: {
  acces: AccesARemettre
  introduction: string
}) {
  const nouveau = acces.mode === 'mot_de_passe'
  return (
    <>
      {nouveau ? introduction : acces.phrase}
      <div
        style={{
          background: 'var(--accent-light)',
          borderRadius: 8,
          padding: '12px 14px',
          margin: '12px 0',
        }}
      >
        {acces.email && (
          <div>
            E-mail : <b>{acces.email}</b>
          </div>
        )}
        {acces.telephone && (
          <div>
            Numéro WhatsApp : <b>{acces.telephone}</b>
          </div>
        )}
        {nouveau && acces.motDePasse && (
          <div>
            Mot de passe temporaire : <b>{acces.motDePasse}</b>
          </div>
        )}
      </div>
    </>
  )
}
